<script lang="ts">
  import { cn } from "#lib/utils"
  import type { SVGComponent } from "@tastyworks/icons-2.0"
  import { alertIconVariants, renderIconByVariant } from "."
  import { getAlertRootContext } from "./AlertRoot.svelte"

  type Props = {
    icon?: SVGComponent
    class?: string | null
  }

  let { icon = undefined, class: cssClass = undefined }: Props = $props()

  const rootCtx = getAlertRootContext()

  let IconComponent = $derived(icon ?? renderIconByVariant($rootCtx.variant))
</script>

{#if IconComponent}
  <IconComponent
    class={cn(alertIconVariants({ variant: $rootCtx.variant }), cssClass)}
  />
{/if}
